<template>
  <div class="container-fluid p-3">
    <div class="card">
      <div class="card-body">
        <h5 class="text-center">REPORTES ROBOTS</h5>

      </div>
      <div class="row">
        <div class="col-12">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
              <td colspan="4"> <button
                  class="btn btn-success"
                  type="button"
                  @click="imprime()"
              >
                Reportar Incidencia
                <i class="fa fa-plus"></i>
              </button></td>
              </tr>
            <tr>
              <th>
                <select
                    class="custom-select"

                    v-model="seleccionado"

                    @change="getConfigEmpresa()"
                >
                  <option value="">SELECCIONAR EMPRESA</option>
                  <option
                      v-for="(t, i) in vempresas"
                      :value="t.id_empresa"
                      :key="t.nombre_empresa + i"
                  >{{ t.nombre_empresa}}</option
                  >
                </select>
                <select
                    class="custom-select"
                    v-model="vueloselec"
                    @change="onChange()"
                >
                  <option value="null">SELECCIONAR VUELO</option>
                  <option
                      v-for="(t, i) in confempresa"
                      :value="t.id_config_empresa"
                      :key="i"
                      @input="onChange"
                  >{{ t.nro_vuelo}}</option
                  >
                </select>
                <!-- <v-select placeholder="Seleccione Centro de Reclusion"  label="pen_nombre" :options="vempresas"  @input="onChangeCentro"></v-select>-->
              </th>
              <th>
                <select
                    class="custom-select"
                    v-model="selectRobot"
                    @change="onChangerbot()"
                >
                  <option value="null">SELECCIONAR ROBOT</option>
                  <option
                      v-for="(t, i) in rbt_robotList"
                      :value="t.nombre"
                      :key="i"
                      @input="onChangerbot"
                  >{{ t.nombre}}</option>
                </select>
                <!--<v-select placeholder="Seleccione Nacionalidad"  label="nombre" :options="confempresa"  @input="onChange"></v-select>-->
              </th>
              <th>
                <b-form-datepicker
                    id="fecha-inicial"
                    placeholder="Seleccione fecha inicio"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    v-model="fecha_ini"
                    @input="fechaInicial"
                    class="mb-2"
                    locale="es"></b-form-datepicker>
              </th>
              <th>
                <b-form-datepicker
                    id="fecha-final"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    placeholder="Seleccione fecha fin"
                    v-model="fecha_fin"
                    @input="fechaFinal"
                    class="mb-2"
                    locale="es">
                </b-form-datepicker>
              </th>
            </tr>
            <tr class="text-center">
              <th>
                <small class="font-weight-bold">EQUIPO</small>
              </th>
              <th><small class="font-weight-bold">FECHA</small></th>
              <th><small class="font-weight-bold">EMPRESA-VUELO</small></th>
              <th><small class="font-weight-bold">ATENDIDOS</small></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in incidenciasgen" :key="index">
              <td>
                <small>{{ item.rbt_nombre }}</small>
              </td>
              <td class="text-center">
                <small> {{ new moment(item.rbt_fecha).format("DD/MM/YYYY") }}</small>
              </td>
              <td class="text-center">
                {{item.rbt_empresa}}
              </td>
              <td class="text-center">
                {{item.rbt_cantidad}}
              </td>
              <td class="text-center">
                <button
                    class="btn btn-success"
                    type="button"
                    @click="obtenerIncidenciasDetalle(item.idincidencias_gen)"
                ><i class="fa fa-bars"> Ver</i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Loading v-show="cargando" />

  </div>
</template>

<script>
import Loading from "../../components/Loading";
//import { required } from "vuelidate/lib/validators";
export default {
  name: "listaRobot",
  components: {
    Loading,
  },
  data() {
    return {
      seleccionado:'',
      seleccionadoerr1:'',
      seleccionadoerr2:'',
      seleccionadoerr3:'',
      seleccionadoerr4:'',
      seleccionadoerr5:'',
      vueloselec:'',
      fields:[],
      vempresas:[],
      confempresa:[],
      dataenv:{},
      perPage: 3,
      currentPage: 1,

      parametro: '',
      incidenciasgenNew:[],
      incidenciasgen:[],
      incidenciasdet:[],
      observacion : {
        descripcion:'',
        vuelo:'',
        fecha:'28/01/16'
      },
      observaciones:[],
      cargando: false,
      erroresUno:[],
      erroresDos:[],
      erroresTres:[],
      erroresCuatro:[],
      erroresCinco:[],
      fecha_ini:null,
      fecha_fin: null,
      rbt_robotList:[],
      selectRobot:null,
      rbt_id_config_flujo:null,
      rbt_robot:null
    };
  },
  methods: {

    async getNombreEmpresas() {
      try {
        let resultados = await this.axios.get(`/get_Empresa_Vuelo`);
        this.vempresas = resultados.data.contenido;
        //  console.log(this.vempresas);
      } catch (error) {
        console.log("catch: ", error);
      }
    },
    async getConfigEmpresa() {
      this.cargando = true;
      try {
        this.cargando = false;
        let resultados = await this.axios.get(`/getConfig_empresa/${this.seleccionado}`);
        this.confempresa = resultados.data.contenido;
        // console.log(this.confempresa);
        this.cargando = false;
      } catch (error) {
        console.log("catch: ", error);
      }
    },


    async obtenerIncidenciasDetalle(id){
      this.$refs["modalObservacion"].show();
      try {
        let resultados = await this.axios.get(`/incidencias-det/${id}`);
        this.incidenciasdet= resultados.data.contenido;
        //console.log(this.incidenciasdet);
      } catch (error){
        console.log("catch: ", error);
      }
    },
    async obtenerErrores(){
      let resultados = await this.axios.get(`/errores`);
      this.erroresUno= resultados.data.contenido;
    },
    onChangeCentro(){

    },
    async onChange(){
      this.rbt_id_config_flujo = this.vueloselec;
      this.obtenerReportes()
    },
    async onChangerbot(){
      console.log(this.selectRobot)
      this.rbt_robot = this.selectRobot;
      this.obtenerReportes()
    },
    async fechaInicial(value){
      this.fecha_ini = value
      this.obtenerReportes()
    },
    async fechaFinal(value){
      this.fecha_fin = value
      this.obtenerReportes()
    },

    hideModalObservado() {
      this.$refs["modalObservacion"].hide();
    },
    seleccionarError(item){
      item.observacion_equipo = "";
    },
    crearReporte(){
      this.$router.push('crearReporte');
    },
    async obtenerReportes(){
      this.rbt_id_config_flujo=this.vueloselec;
      this.rbt_robot= this.selectRobot;
      try {
        ///${id_config_flujo}/${fecha_ini}/${fecha_fin}
        let resultados = await this.axios.get(`/reporte-robot/${this.rbt_robot}/${this.fecha_ini}/${this.fecha_fin}/${this.rbt_id_config_flujo}`);
        this.incidenciasgenNew= resultados.data.contenido;
        this.incidenciasgen = this.incidenciasgenNew;
        //console.log(this.incidenciasgen)
      } catch (error){
        console.log("catch: ", error);
      }
    },
    crearDescarga(response, title) {
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "blob" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    async imprime() {
       this.rbt_id_config_flujo=this.vueloselec;
      this.rbt_robot= this.selectRobot;
      let config = { headers: { token: this.token }, responseType: "blob" };
      try {
        let resultados = await this.axios.get(`/reporte_robot/${this.rbt_robot}/${this.fecha_ini}/${this.fecha_fin}/${this.rbt_id_config_flujo}`,config);
  
        await this.crearDescarga(resultados, "reporte.pdf");
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerRobots(){
      let resultados = await this.axios.get(`/robots`);
      this.rbt_robotList = resultados.data.contenido;
      //console.log(this.rbt_robotList);
    }
  },
  created() {
    this.obtenerErrores(),
        this.getNombreEmpresas(),
        this.obtenerReportes(),
        this.obtenerRobots()

  },

};
</script>
